import "./MenuDropdownComponent.scss";
import React, {ReactNode, useCallback, useEffect, useRef, useState} from "react";

interface MenuDropdownComponentProps {
    menuBase: ReactNode | null;
}

const MenuDropdownComponent = (props: React.PropsWithChildren<MenuDropdownComponentProps>) => {

    const {menuBase, children} = props;
    const menuRef = useRef<any>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleMenuDropDown = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    // useEffect(() => {
    //     OutsideClickListener(listening, setListening, menuRef, setIsOpen)
    // }, [listening]);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    const handleClickOutside = (event:any) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };


    return (
        <div ref={menuRef} className={'menu-dropdown-component-menu ' + (isOpen ? "active" : "")}>
            <div onClick={toggleMenuDropDown}>
                {menuBase}
            </div>
            <ul className="menu-dropdown-menu__content" onClick={toggleMenuDropDown}>
                {children}
            </ul>
        </div>
    );

};

export default MenuDropdownComponent;

// ****************************** USAGE ****************************** //

// const [isContextMenuOpened, setIsContextMenuOpened] = useState<boolean | undefined>(undefined);
//
// <MenuDropdownComponent
//     menuBase={
//         <ButtonComponent>Context Menu</ButtonComponent>
//     }
//     menuOptions={[
//         <CheckBoxComponent label={"Option 1"}/>,
//         <CheckBoxComponent label={"Option 2"}/>,
//         <CheckBoxComponent label={"Close"} onChange={()=>{setIsContextMenuOpened(false)}}/>,
//     ]}
//     isOpen={isContextMenuOpened}
//     onOpen={()=>{setIsContextMenuOpened(true)}}
//     onClose={()=>{setIsContextMenuOpened(false)}}
// />

// ****************************** USAGE ****************************** //
